var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"horizontal-scrollbar",on:{"scroll":_vm.onScroll}},[_c('div',{ref:"content",staticClass:"horizontal-scrollbar__content"})])
}
var staticRenderFns = []

export { render, staticRenderFns }